<div *ngIf="block" class="d-flex w-100 px-2 py-4 align-items-center" [ngClass]="{
        'justify-content-center': !block.label_cta,
        'justify-content-between': block.label_cta
    }">
    <div class="d-flex flex-column text-center">
        <div *ngIf="block.titolo_generale">
            <p class="mb-0 ls-h1-page-title-collapsed text-brand-10" [innerHTML]="block.titolo_generale"></p>
        </div>
        <div *ngIf="block.sottotitolo_generale">
            <p class="mt-2 ls-p text-neutral-40">{{block.sottotitolo_generale}}</p>
        </div>
    </div>
    <div *ngIf="block.label_cta" class="hidden-phone">
        <button class="btn btn-transparent py-2">{{block.label_cta}}</button>
    </div>
</div>